import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap"
import { useAppDispatch, useAppSelector } from "../../app/store";
import { useNavigate, useParams } from "react-router-dom";
import { addQuestion, deleteQuestion, getQuestionCategoryById, getQuestions } from "../../features/jobSlice";
import { toast } from "react-toastify";
import { PuffLoader } from "react-spinners";


const JobQuestions = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const {singleQuestionCategory, questions, isLoading} = useAppSelector((state) => state.job);
  const navigate = useNavigate();

  
  const [options, setOptions] = useState<{ options: string }[]>([
    { options: "Yes" },
    { options: "No" }
  ]);



  const dispatch = useAppDispatch();
  const { id } = useParams();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);



  useEffect(() => {
    dispatch(getQuestionCategoryById(id));
    dispatch(getQuestions(id));
  }, [dispatch]);

  const handleSaveQuestion = () => {
    const data = {
      jobQuestion: question,
      answer: answer,
      options: options,
      category_id: id
    };

    dispatch(addQuestion(data))
      .unwrap()
      .then(() => {
        setQuestion("");
        setAnswer("");
        setOptions([
          { options: "Yes" },
          { options: "No" }
        ]);
        handleClose();
        dispatch(getQuestions(id));
        toast.success("Question added successfully!");
      })
      .catch((error) => {
        toast.error("Failed to add question: " + error.message);
      });
  };

  const handleDelete = (id:string | undefined) => {
    // Assuming you have a deleteQuestion action
    dispatch(deleteQuestion(id))
      .unwrap()
      .then(() => {
   
        toast.success("Question deleted successfully!");
        // Optionally, you can refresh the questions list here
        dispatch(getQuestions(singleQuestionCategory.id));
      })
      .catch((error) => {
        toast.error("Failed to delete question: " + error.message);
      });
  }

if(isLoading || !singleQuestionCategory) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <PuffLoader color="#36d7b7" size={60} />
      </div>
    );
  } 

  console.log(questions)

      
  return (
    <div> <Row>
                <Col md={9} sm={12} className="p-3">
                    <div className="d-flex flex-row justify-content-between pt-3">
                        <div>
                            <h5 >{singleQuestionCategory.category_name}</h5>
                        </div>
                      

                    </div>
                    <hr />

                    {questions && questions.data.length > 0 ? (
                        questions.data.map((question:any) => (
                            <div key={question.id} className="mb-3">
                                <div className="d-flex flex-row justify-content-between align-items-center">
                                    <div>
                                        <h6>Question</h6>
                                        <p className="mb-2">{question.jobQuestion}</p>

                                        <h6>Answer</h6>
                                        <p className="text-muted mb-0">{question.answer}</p>
                                    </div>
                                    <div>
                                   <a href={`edit/${question.id}`}><i className="bi bi-pencil-square me-2"></i></a> 
                                            <i className="bi bi-trash" onClick={() => handleDelete(question.id)} style={{cursor:'pointer'}}></i>
                                       
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <img src="/images/question.png" alt="question" className="img-fluid" />
                            <p className="text-center">No Questions Available</p>
                            </div>
                        )}

                             <div className="d-flex flex-row justify-content-center">
                       <Button variant="secondary" className="rounded-0 text-white mt-3 px-5" onClick={handleShow}><i className="bi bi-plus"></i>  Add Question</Button>
                       </div>

                    
                </Col>
                <Col md={3} sm={12} style={{ backgroundColor: "#C2CFE0" }}>
                    <div className="p-3">
                        <div className="mb-2">
                            <h5>Configure your Job Type</h5>
                        </div>

                        <p>Do you wish to send a warm and personalized
                            acknowledgement email to every candidate
                            who applies to your company? Do you wish
                            to send a policy guide to help any employee
                            who requests a transfer? Email notifications
                            help you customize (almost) every email that
                            is sent from Freshteam to candidates,
                            employees, managers etc.</p>
                    </div>

                </Col>
            </Row>

             <Modal
                            show={show}
                            onHide={handleClose}
                            backdrop="static"
                            keyboard={false}
                            centered
                        >
                            <Modal.Header closeButton className="border-0">
                                <Modal.Title><h3 className="title-modal">ADD CATEGORY QUESTION</h3></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="form-group">
                                    <label className="mb-2">Enter Question</label>
                                    <textarea className="form-control rounded-0" name="question" onChange={(e)=>setQuestion(e.target.value)}></textarea>
                                </div>

                                <div className="form-group mt-3">
                                   <label>Select Answer</label>
                                <div>
                                   <input type="radio" className="form-check-input" name="answer" value="Yes" onChange={(e)=>setAnswer(e.target.value)}  /> Yes
                                   <input type="radio" className="form-check-input ms-3" name="answer" value="No" onChange={(e)=>setAnswer(e.target.value)}/> No
                                </div> 
                                </div>

                                


                            </Modal.Body>
                            <Modal.Footer className="border-0 d-flex justify-content-between">
                               
                                       <Button variant="danger" className="rounded-0" onClick={handleClose}>
                                        Cancel
                                    </Button> 
                                   
                                       <Button variant="secondary" className="text-white rounded-0" onClick={handleSaveQuestion}>Save</Button> 
                                    
            
                            </Modal.Footer>
                        </Modal>
            </div>
  )
}

export default JobQuestions